import React from 'react';
const PrivacyPolicy = () => {
  return <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-1196">
      <div className="max-w-3xl mx-auto" data-id="element-1197">
        <h1 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1198">
          Privacy Policy
        </h1>
        <div className="text-sm text-gray-500 mb-8" data-id="element-1199">
          Last updated: June 1, 2023
        </div>
        <div className="prose prose-lg max-w-none" data-id="element-1200">
          <p data-id="element-1201">
            At LaraDevs, we take your privacy seriously. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you visit our website and use our services.
          </p>
          <h2 data-id="element-1202">Information We Collect</h2>
          <p data-id="element-1203">
            We collect information that you provide directly to us when you
            register for an account, create or modify your profile, set
            preferences, or make purchases through the Services.
          </p>
          <h3 data-id="element-1204">Personal Information</h3>
          <p data-id="element-1205">When you register for an account, we may collect:</p>
          <ul data-id="element-1206">
            <li data-id="element-1207">Your name, email address, and contact information</li>
            <li data-id="element-1208">
              Profile information such as your photo, bio, skills, and location
            </li>
            <li data-id="element-1209">Payment information for transactions</li>
            <li data-id="element-1210">Communications you send to us</li>
          </ul>
          <h3 data-id="element-1211">Automatically Collected Information</h3>
          <p data-id="element-1212">When you access or use our Services, we automatically collect:</p>
          <ul data-id="element-1213">
            <li data-id="element-1214">Log information (IP address, browser type, pages visited)</li>
            <li data-id="element-1215">Device information</li>
            <li data-id="element-1216">Location information</li>
            <li data-id="element-1217">Cookie data</li>
          </ul>
          <h2 data-id="element-1218">How We Use Your Information</h2>
          <p data-id="element-1219">
            We may use the information we collect for various purposes,
            including to:
          </p>
          <ul data-id="element-1220">
            <li data-id="element-1221">Provide, maintain, and improve our Services</li>
            <li data-id="element-1222">Process transactions and send related information</li>
            <li data-id="element-1223">
              Send technical notices, updates, security alerts, and support
              messages
            </li>
            <li data-id="element-1224">Respond to your comments, questions, and requests</li>
            <li data-id="element-1225">
              Communicate with you about products, services, offers, and events
            </li>
            <li data-id="element-1226">Monitor and analyze trends, usage, and activities</li>
            <li data-id="element-1227">
              Detect, investigate, and prevent fraudulent transactions and other
              illegal activities
            </li>
            <li data-id="element-1228">
              Personalize the Services and provide advertisements, content, or
              features that match user profiles or interests
            </li>
          </ul>
          <h2 data-id="element-1229">Sharing of Information</h2>
          <p data-id="element-1230">
            We may share the information we collect in various ways, including:
          </p>
          <ul data-id="element-1231">
            <li data-id="element-1232">
              With vendors, consultants, and other service providers who need
              access to such information to carry out work on our behalf
            </li>
            <li data-id="element-1233">
              In response to a request for information if we believe disclosure
              is in accordance with, or required by, any applicable law,
              regulation, or legal process
            </li>
            <li data-id="element-1234">
              If we believe your actions are inconsistent with our user
              agreements or policies, or to protect the rights, property, and
              safety of LaraDevs or others
            </li>
            <li data-id="element-1235">
              In connection with, or during negotiations of, any merger, sale of
              company assets, financing, or acquisition of all or a portion of
              our business by another company
            </li>
            <li data-id="element-1236">With your consent or at your direction</li>
          </ul>
          <h2 data-id="element-1237">Your Choices</h2>
          <p data-id="element-1238">
            You have several choices regarding the information we collect and
            how it is used:
          </p>
          <ul data-id="element-1239">
            <li data-id="element-1240">
              Account Information: You may update, correct, or delete your
              account information at any time by logging into your account
            </li>
            <li data-id="element-1241">
              Cookies: Most web browsers are set to accept cookies by default.
              If you prefer, you can usually choose to set your browser to
              remove or reject cookies
            </li>
            <li data-id="element-1242">
              Promotional Communications: You may opt out of receiving
              promotional communications from us by following the instructions
              in those communications
            </li>
          </ul>
          <h2 data-id="element-1243">Contact Us</h2>
          <p data-id="element-1244">
            If you have any questions about this Privacy Policy, please contact
            us at:
          </p>
          <p data-id="element-1245">
            Email: privacy@laradevs.com
            <br data-id="element-1246" />
            Address: 123 Developer Way, Suite 456, San Francisco, CA 94103
          </p>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;